import { render, staticRenderFns } from "./index-ksupplys.vue?vue&type=template&id=3164aea6&scoped=true"
import script from "./index-ksupplys.vue?vue&type=script&lang=js"
export * from "./index-ksupplys.vue?vue&type=script&lang=js"
import style0 from "./index-ksupplys.vue?vue&type=style&index=0&id=3164aea6&prod&lang=scss&scoped=true"
import style1 from "./index-ksupplys.vue?vue&type=style&index=1&id=3164aea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164aea6",
  null
  
)

export default component.exports